import React, { useState, useRef } from "react";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../../../Axiosinstance";
import {
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Grid,
  CircularProgress,
  MenuItem,
  Box,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { CheckCircleOutline, CloudUpload } from "@mui/icons-material";
import { CLOUDINARY_UPLOAD_PRESET, baseURL } from "../../../common";
import IconButton from "@mui/material/IconButton";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

const ExistingCompanyForm = ({ fee, dataFrom }) => {
  const { batchid } = useParams(); // Extract companyId and batchId from URL parameters
  const [openModal, setOpenModal] = useState(false); // For showing modal
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [uen, setUen] = useState("");
  const [uenAvailable, setUenAvailable] = useState(true);
  const [uenMessage, setUenMessage] = useState("");
  const [companyId, setCompanyId] = useState(null); // State for storing the company ID
  const [registerId, setRegisterId] = useState("");

  const [formData, setFormData] = useState({
    contactNumber: "",
    contactPerson: "",
    courseAmount: fee,
    promotionCode: "",
    contactDesignation: "",
    contactEmail: "",
    contactEmails: [""],
    contactPhoneNumbers: [""],
    contactTelephoneNumbers: [""],
    students: [
      {
        sector: "",
        name: "",
        idType: "",
        nric: "",
        nationality: "",
        dob: "",
        emailId: [""],
        contactNumber: [""],
        registration_Form: "",
        supporting_Documents: "",
        ic: "",
      },
    ],
  });

  // Create a ref for the UEN input field
  const uenRef = useRef(null);

  const addCompanyDetail = () => {
    setFormData((prevState) => ({
      ...prevState,
      students: [
        ...prevState.students,
        {
          sector: "",
          name: "",
          idType: "",
          nric: "",
          nationality: "",
          dob: "",
          emailId: [""],
          contactNumber: [""],
          registration_Form: "",
          supporting_Documents: "",
          ic: "",
        },
      ],
    }));
  };

  const handleStudentChange = (index, field, value) => {
    const updatedStudents = [...formData.students];
    updatedStudents[index][field] = value;
    setFormData((prevState) => ({
      ...prevState,
      students: updatedStudents,
    }));
  };

  const handleUENChange = (e) => {
    const newUEN = e.target.value;
    setUen(newUEN);
  };

  const checkUENAvailability = async (uen) => {
    try {
      const response = await axios.get(`/wsq/companies/check-uen?uen=${uen}`);

      if (response.status === 200) {
        // UEN is taken, get companyId from response
        setCompanyId(response.data.companyId);
        setUenAvailable(true);
        setUenMessage(
          <Typography variant="body1" component="span">
            Welcome,{" "}
            <strong style={{ fontSize: "1.2em" }}>
              {response.data.companyName}
            </strong>
            . Your company details are recognized.
          </Typography>
        );
      } else if (response.status === 202) {
        // UEN is new, not allowed to register
        setUenAvailable(false);
        setUenMessage(
          "The UEN number entered was not found in our database. Please register as a new client company using the option above."
        );
      }
    } catch (error) {
      console.error("Error checking UEN availability:", error);
      setUenAvailable(false);
      setUenMessage("Error checking UEN availability.");
    }
  };

  const validateUEN = (uen) => {
    // Check if UEN is defined and its length is between 7 and 15
    return uen && uen.length >= 7 && uen.length <= 15;
  };

  const handleUENBlur = () => {
    if (validateUEN(uen)) {
      checkUENAvailability(uen);
    } else {
      setUenAvailable(false);
      setUenMessage("Invalid UEN format. Please enter a valid UEN.");
    }
  };

  

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check if UEN is available and valid before submitting
    if (!uenAvailable || !validateUEN(uen) || companyId === null) {
      // Focus on the UEN input field
      if (uenRef.current) {
        uenRef.current.focus();
      }
      return;
    }
    console.log(formData);

    // console.log(requestData);
    setLoading(true);
    // Send the request to the API using Axios with the assigned companyId
    axios
      .post(
        `/wsq/companies/add?companyId=${companyId}&batchId=${batchid}`,
        formData
      )
      .then((response) => {
        setRegisterId(response.data.registerId);
        setOpenModal(true); // Show success modal
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle error (e.g., display an error message)
      })
      .finally(() => {
        setLoading(false); // Stop loading
      });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    // navigate('/HomeContainer'); // Navigate to HomeContainer after modal close
    if (dataFrom === "admin") {
      navigate("/wsq/student");
    } else {
      navigate("/HomeContainer"); // Replace '/AnotherPath' with the desired route
    }
  };

  const handleFileUpload = async (e, index, fieldName) => {
    try {
      const file = e.target.files[0];

      // Check if a file is selected
      if (!file) return;

      const formDataUpload = new FormData(); // Create a new FormData object for file upload
      formDataUpload.append("file", file);
      formDataUpload.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);

      const response = await fetch(baseURL, {
        method: "POST",
        body: formDataUpload,
      });

      const data = await response.json();

      if (data.secure_url) {
        const uploadedFileUrl = data.secure_url;

        const updatedStudents = [...formData.students];
        updatedStudents[index][fieldName] = uploadedFileUrl; // Update the specific field with the uploaded file
        setFormData({
          ...formData,
          students: updatedStudents,
        });
      }
    } catch (err) {
      console.error("File upload error:", err);
    }
  };

  // General function to handle changes in array fields
  const handleArrayChange = (fieldPath, index, value) => {
    const updatedData = { ...formData };
    const fieldArray = getNestedField(updatedData, fieldPath);
    if (fieldArray) {
      fieldArray[index] = value;
      setFormData(updatedData);
    }
  };

  // General function to add a new item to an array field
  const addArrayItem = (fieldPath, newValue = "") => {
    const updatedData = { ...formData };
    const fieldArray = getNestedField(updatedData, fieldPath);
    if (fieldArray) {
      fieldArray.push(newValue); // Add new item
      setFormData(updatedData);
    }
  };

  // General function to remove an item from an array field, ensuring at least one item remains
  const removeArrayItem = (fieldPath, index) => {
    const updatedData = { ...formData };
    const fieldArray = getNestedField(updatedData, fieldPath);
    if (fieldArray && fieldArray.length > 1) {
      fieldArray.splice(index, 1); // Remove item at specified index
      setFormData(updatedData);
    }
  };

  // Helper function to access nested fields based on path
  const getNestedField = (obj, path) => {
    return path.reduce(
      (acc, key) => (acc && acc[key] !== undefined ? acc[key] : null),
      obj
    );
  };

  const removeStudentDetail = (index) => {
    setFormData((prevState) => ({
      ...prevState,
      students: prevState.students.filter((_, i) => i !== index),
    }));
  };

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        label="UEN"
        variant="outlined"
        fullWidth
        margin="normal"
        required
        value={uen}
        onChange={handleUENChange}
        onBlur={handleUENBlur}
        error={!uenAvailable}
        helperText={uenMessage}
        inputRef={uenRef} // Attach the ref here
      />
      <TextField
        label="Contact Person"
        variant="outlined"
        fullWidth
        margin="normal"
        required
        name="contactPerson"
        value={formData.contactPerson}
        onChange={handleChange}
      />
      <TextField
        label="Contact Number"
        variant="outlined"
        fullWidth
        margin="normal"
        required
        name="contactNumber"
        value={formData.contactNumber}
        onChange={handleChange}
      />

      {/* <Grid item xs={12} sm={6}> */}
      <TextField
        label="Contact Email"
        variant="outlined"
        fullWidth
        margin="normal"
        value={formData.contactEmail}
        onChange={handleChange}
        name="contactEmail"
      />
      <TextField
        label="contact Designation"
        variant="outlined"
        fullWidth
        margin="normal"
        value={formData.contactDesignation}
        onChange={handleChange}
        name="contactDesignation"
      />
      {/* </Grid> */}

      {/* Contact Emails */}
      <Typography variant="h6" gutterBottom>
        Contact Emails
      </Typography>
      {formData.contactEmails.map((email, emailIndex) => (
        <Grid
          container
          alignItems="center"
          spacing={1}
          key={emailIndex}
          style={{ marginBottom: "10px" }}
        >
          {/* Email Input */}
          <Grid item xs={10}>
            <TextField
              label={`Contact Email ${emailIndex + 1}`}
              variant="outlined"
              fullWidth
              value={email}
              onChange={(e) =>
                handleArrayChange(["contactEmails"], emailIndex, e.target.value)
              }
            />
          </Grid>

          {/* Add Button */}
          <Grid>
            <IconButton
              color="primary"
              onClick={() => addArrayItem(["contactEmails"])}
            >
              <AddCircleOutlineIcon />
            </IconButton>
          </Grid>

          {/* Remove Button */}
          <Grid>
            {emailIndex > 0 && (
              <IconButton
                color="error"
                onClick={() => removeArrayItem(["contactEmails"], emailIndex)}
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            )}
          </Grid>
        </Grid>
      ))}

{/* Contact Phone Numbers */}
<Typography variant="h6" gutterBottom>
  Contact Phone Numbers
</Typography>
{formData.contactPhoneNumbers.map((phone, phoneIndex) => (
  <Grid
    container
    alignItems="center"
    spacing={1}
    key={phoneIndex}
    style={{ marginBottom: "10px" }}
  >
    {/* Phone Input */}
    <Grid item xs={10}>
      <TextField
        label={`Contact Phone Number ${phoneIndex + 1}`}
        variant="outlined"
        fullWidth
        value={phone}
        onChange={(e) => {
          const value = e.target.value;

          // Validate input: starts with '6' and allows up to 8 digits
          if (/^[689]\d{0,7}$/.test(value) || value === "") {
            handleArrayChange(
              ["contactPhoneNumbers"],
              phoneIndex,
              value
            );
          }
        }}
        onInput={(e) => {
          // Limit input to 8 digits
          if (e.target.value.length > 8) {
            e.target.value = e.target.value.slice(0, 8);
          }
        }}
        required
        placeholder="6/8/9/XXXXXX"  // Example format
      />
    </Grid>

    {/* Add Button */}
    <Grid item>
      <IconButton
        color="primary"
        onClick={() =>
          addArrayItem(["contactPhoneNumbers"], "")
        }
      >
        <AddCircleOutlineIcon />
      </IconButton>
    </Grid>

    {/* Remove Button */}
    <Grid item>
      {phoneIndex > 0 && (
        <IconButton
          color="error"
          onClick={() =>
            removeArrayItem(["contactPhoneNumbers"], phoneIndex)
          }
        >
          <RemoveCircleOutlineIcon />
        </IconButton>
      )}
    </Grid>
  </Grid>
))}

<Grid item>
  <Button
    variant="outlined"
    color="secondary"
    onClick={() =>
      addArrayItem(["contactPhoneNumbers"], "")
    }
  >
    Add Contact Phone Number
  </Button>
</Grid>


{/* Contact Telephone Numbers */}
<Typography variant="h6" gutterBottom>
  Contact Telephone Numbers
</Typography>
{formData.contactTelephoneNumbers.map((telephone, telephoneIndex) => (
  <Grid
    container
    alignItems="center"
    spacing={1}
    key={telephoneIndex}
    style={{ marginBottom: "10px" }}
  >
    {/* Telephone Input */}
    <Grid item xs={10}>
      <TextField
        label={`Contact Telephone Number ${telephoneIndex + 1}`}
        variant="outlined"
        fullWidth
        value={telephone}
        onChange={(e) => {
          const value = e.target.value;

          // Validate input: starts with '6' and allows up to 8 digits
          if (/^6\d{0,7}$/.test(value) || value === "") {
            handleArrayChange(
              ["contactTelephoneNumbers"],
              telephoneIndex,
              value
            );
          }
        }}
        onInput={(e) => {
          // Limit input to 8 digits
          if (e.target.value.length > 8) {
            e.target.value = e.target.value.slice(0, 8);
          }
        }}
        required
        placeholder="6XXXXXXX"  // Example format
      />
    </Grid>

    {/* Add Button */}
    <Grid item>
      <IconButton
        color="primary"
        onClick={() =>
          addArrayItem(["contactTelephoneNumbers"], "")
        }
      >
        <AddCircleOutlineIcon />
      </IconButton>
    </Grid>

    {/* Remove Button */}
    <Grid item>
      {telephoneIndex > 0 && (
        <IconButton
          color="error"
          onClick={() =>
            removeArrayItem(["contactTelephoneNumbers"], telephoneIndex)
          }
        >
          <RemoveCircleOutlineIcon />
        </IconButton>
      )}
    </Grid>
  </Grid>
))}

<Grid item>
  <Button
    variant="outlined"
    color="secondary"
    onClick={() =>
      addArrayItem(["contactTelephoneNumbers"], "")
    }
  >
    Add Contact Telephone Number
  </Button>
</Grid>


      {formData.students.map((student, index) => (
        <Box key={index} sx={{ marginBottom: 3 }}>
          <strong>Trainee Details:</strong>
          <Grid container spacing={2} sx={{ marginTop: 2 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Sector"
                variant="outlined"
                fullWidth
                margin="normal"
                required
                value={student.sector}
                onChange={(e) =>
                  handleStudentChange(index, "sector", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Student Name (As per NRIC/FIN/Passport)"
                variant="outlined"
                fullWidth
                margin="normal"
                required
                value={student.name}
                onChange={(e) =>
                  handleStudentChange(index, "name", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Nationality" // New field for nationality
                variant="outlined"
                fullWidth
                margin="normal"
                value={student.nationality}
                onChange={(e) =>
                  handleStudentChange(index, "nationality", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              {/* <TextField
                label="ID Type"
                variant="outlined"
                fullWidth
                margin="normal"
                required
                value={student.idType}
                onChange={(e) => handleStudentChange(index, 'idType', e.target.value)}
              /> */}
              <TextField
                label="ID Type"
                name="idType"
                select
                variant="outlined"
                fullWidth
                margin="normal"
                required
                value={student.idType}
                onChange={(e) =>
                  handleStudentChange(index, "idType", e.target.value)
                }
              >
                <MenuItem value="NRIC">NRIC</MenuItem>
                <MenuItem value="FIN">FIN</MenuItem>
                <MenuItem value="Passport">Passport</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label={student.idType || "ID"}
                variant="outlined"
                fullWidth
                margin="normal"
                required
                value={student.nric}
                onChange={(e) =>
                  handleStudentChange(index, "nric", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Date of Birth"
                variant="outlined"
                fullWidth
                margin="normal"
                type="date"
                InputLabelProps={{ shrink: true }}
                required
                value={student.dob}
                onChange={(e) =>
                  handleStudentChange(index, "dob", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              {student.contactNumber.map((number, numberIndex) => (
                <Grid container spacing={2} key={numberIndex}>
                  <Grid item xs={8}>
                    <TextField
                      label={`Contact Number ${numberIndex + 1}`}
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      required
                      value={number}
                      onChange={(e) => {
                        const value = e.target.value;
              
                        // Validate input: starts with '6' and allows up to 8 digits
                        if (/^6\d{0,7}$/.test(value) || value === "") {
                          handleArrayChange(
                            ["students", index, "contactNumber"],
                            numberIndex,
                            value
                          );
                        }
                      }}
                      onInput={(e) => {
                        // Limit input to 8 digits
                        if (e.target.value.length > 8) {
                          e.target.value = e.target.value.slice(0, 8);
                        }
                      }}
                      placeholder="6XXXXXXX" 
                    />
                  </Grid>
                  <Grid item xs={3} container justifyContent="flex-start" spacing={1} alignItems="center">
                    <Grid item>
                      <IconButton

                        color="secondary"
                        onClick={() =>
                          removeArrayItem(
                            ["students", index, "contactNumber"],
                            numberIndex
                          )
                        }
                        disabled={student.contactNumber.length === 1}
                      >
                        <RemoveCircleOutlineIcon />
                      </IconButton>
                    </Grid>
                    <Grid item>
                      <IconButton
                                               color="primary"
                        onClick={() =>
                          addArrayItem(["students", index, "contactNumber"], "")
                        }
                      >
                        <AddCircleOutlineIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Grid>
              ))}

            </Grid>

            <Grid item xs={12} sm={6}>
              {student.emailId.map((email, emailIndex) => (
                <Grid container spacing={2} key={emailIndex}>
                  <Grid item xs={9}>
                    <TextField
                      label={`Email ID ${emailIndex + 1}`}
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      type="email"
                      required
                      value={email}
                      onChange={(e) =>
                        handleArrayChange(
                          ["students", index, "emailId"],
                          emailIndex,
                          e.target.value
                        )
                      }
                    />
                  </Grid>
                  <Grid item xs={3} container justifyContent="flex-start" spacing={1} alignItems="center">
                    <Grid item>
                      <IconButton
                        color="secondary"
                        onClick={() =>
                          removeArrayItem(
                            ["students", index, "emailId"],
                            emailIndex
                          )
                        }
                        disabled={student.emailId.length === 1}
                      >
                        <RemoveCircleOutlineIcon />
                      </IconButton>
                    </Grid>
                    <Grid item>
                      <IconButton

                        color="primary"
                        onClick={() =>
                          addArrayItem(["students", index, "emailId"], "")
                        }
                      >
                        <AddCircleOutlineIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Grid>
              ))}

            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Registration Form"
                variant="outlined"
                fullWidth
                margin="normal"
                type="file"
                accept=".pdf,.docx,.jpeg,.png"
                onChange={(e) =>
                  handleFileUpload(e, index, "registration_Form")
                }
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="IC"
                variant="outlined"
                fullWidth
                margin="normal"
                type="file"
                accept=".pdf,.docx,.jpeg,.png"
                onChange={(e) => handleFileUpload(e, index, "ic")}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Supporting Documents"
                variant="outlined"
                fullWidth
                margin="normal"
                type="file"
                accept=".pdf,.docx,.jpeg,.png"
                onChange={(e) =>
                  handleFileUpload(e, index, "supporting_Documents")
                }
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>

          {formData.students.length > 1 && (
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => removeStudentDetail(index)}
              style={{ fontSize: "10px", marginTop: "10px" }}
            >
              <RemoveIcon /> Remove Student
            </Button>
          )}
        </Box>
      ))}

      <Button
        type="button"
        variant="outlined"
        style={{ fontSize: "10px", marginTop: "10px" }}
        color="primary"
        onClick={addCompanyDetail}
      >
        <AddIcon /> Add More Trainees
      </Button>

      <Typography variant="h6" style={{ marginTop: "20px" }}>
        Course Amount: {fee}
      </Typography>

      <TextField
        label="Promotion Code" // New field for promotion code
        variant="outlined"
        fullWidth
        margin="normal"
        name="promotionCode" // The name should match the field in state
        value={formData.promotionCode} // Bind the value to formData.promotionCode
        onChange={handleChange} // Call handleChange to update the value
      />

      <div style={{ display: "flex", justifyContent: "flex-end", gap: "16px" }}>
        <Button
          type="button"
          variant="contained"
          color="error"
          onClick={() => {
            if (dataFrom === "admin") {
              navigate("/wsq/student");
            } else {
              navigate("/HomeContainer"); // Replace '/AnotherPath' with the desired route
            }
          }}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : "Submit"}
        </Button>
      </div>

      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogTitle
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "24px",
            color: "#4caf50",
          }}
        >
          Registration Successfull
        </DialogTitle>
        <DialogContent>
          <Grid container justifyContent="center">
            {/* Success Icon */}
            <CheckCircleOutline
              style={{ fontSize: "80px", color: "#4caf50" }}
            />
          </Grid>
          <DialogContentText
            style={{
              textAlign: "center",
              fontSize: "18px",
              marginTop: "20px",
              color: "#555",
            }}
          >
            Your registration was successfully submitted!
          </DialogContentText>
          <DialogContentText
            style={{
              textAlign: "center",
              fontSize: "16px",
              marginTop: "10px",
              color: "#777",
            }}
          >
            {" "}
            Your Registration ID is: <strong>{registerId}</strong>
            <br />
            We have received your information and will be in touch with further
            details shortly.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Grid container justifyContent="center">
            <Button
              onClick={handleCloseModal}
              variant="contained"
              style={{
                backgroundColor: "#4caf50",
                color: "#fff",
                padding: "10px 30px",
                fontSize: "16px",
              }}
            >
              OK
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    </form>
  );
};

export default ExistingCompanyForm;
